/**
 * Scent Finder Quiz - Tag-Based System with Cart Monitoring
 * -------------------------------------------------------------
 * CHANGES: Removed button toggle to "Added" state, added toast notification
 * All other functionality remains EXACTLY the same!
 */
(function () {
  'use strict';

  var ORDER = ['1', '2', '3', '4', '5', 'email', 'result'];

  function ScentFinderQuiz(sectionId, options) {
    this.sectionId = sectionId;
    this.options = options || {};
    this.root = document.getElementById('scent-quiz-' + sectionId);
    if (!this.root) return;

    this.selectedTags = [];
    this.currentIndex = 0;
    this.products = this._loadData();
    this.fallbackProducts = this._loadFallbackProducts();

    this._cacheEls();
    this._bindEvents();
    this._render();
    
    // Start monitoring cart
    this._monitorCart();
  }

  ScentFinderQuiz.prototype._loadData = function () {
    var script = document.querySelector('script[data-scent-quiz-data="' + this.sectionId + '"]');
    if (!script) return [];
    try {
      var parsed = JSON.parse(script.textContent);
      return (parsed && parsed.products) || [];
    } catch (e) {
      console.error('Scent Finder Quiz: could not parse product data', e);
      return [];
    }
  };

  ScentFinderQuiz.prototype._loadFallbackProducts = function () {
    var fallbackBlock = this.root.querySelector('[data-fallback-products]');
    if (fallbackBlock) {
      try {
        return JSON.parse(fallbackBlock.textContent);
      } catch (e) {
        return [];
      }
    }
    return [];
  };

  ScentFinderQuiz.prototype._cacheEls = function () {
    this.questionEls = Array.prototype.slice.call(this.root.querySelectorAll('[data-question]'));
    this.progressFill = this.root.querySelector('[data-progress-fill]');
    this.stepLabel = this.root.querySelector('[data-step-label]');
    this.backBtn = this.root.querySelector('[data-quiz-back]');
    this.emailForm = this.root.querySelector('[data-email-form]');
    this.emailInput = this.root.querySelector('[data-email-input]');
    this.emailError = this.root.querySelector('[data-email-error]');
    this.emailSubmit = this.root.querySelector('[data-email-submit]');
    this.resultTitle = this.root.querySelector('[data-result-title]');
    this.resultNote = this.root.querySelector('[data-result-note]');
    this.resultProducts = this.root.querySelector('[data-result-products]');
    this.retakeBtn = this.root.querySelector('[data-retake]');
    
    // Create toast container if it doesn't exist
    this._createToastContainer();
  };

  ScentFinderQuiz.prototype._createToastContainer = function () {
    if (!document.querySelector('.scent-quiz-toast-container')) {
      var container = document.createElement('div');
      container.className = 'scent-quiz-toast-container';
      container.setAttribute('aria-live', 'polite');
      document.body.appendChild(container);
    }
  };

  ScentFinderQuiz.prototype._showToast = function (message) {
    var container = document.querySelector('.scent-quiz-toast-container');
    if (!container) return;

    var toast = document.createElement('div');
    toast.className = 'scent-quiz-toast';
    toast.textContent = message;
    container.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(function () {
      toast.classList.add('show');
    });

    // Remove after 3 seconds
    setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 2500);
  };

  ScentFinderQuiz.prototype._bindEvents = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      var optionBtn = e.target.closest('[data-value]');
      if (optionBtn && optionBtn.closest('.scent-quiz-options')) {
        self._selectOption(optionBtn);
        return;
      }

      var addBtn = e.target.closest('[data-add-to-cart]');
      if (addBtn) {
        self._addToCart(addBtn);
        return;
      }
    });

    if (this.backBtn) {
      this.backBtn.addEventListener('click', function () {
        self._goTo(self.currentIndex - 1);
      });
    }

    if (this.emailForm) {
      this.emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        self._submitEmail();
      });
    }

    if (this.retakeBtn) {
      this.retakeBtn.addEventListener('click', function () {
        self.selectedTags = [];
        self._deselectAll();
        
        // Clear email field on retake
        if (self.emailInput) {
          self.emailInput.value = '';
          self.emailInput.classList.remove('error');
        }
        if (self.emailError) {
          self.emailError.hidden = true;
        }
        if (self.emailSubmit) {
          self.emailSubmit.removeAttribute('disabled');
          self.emailSubmit.classList.remove('loading');
          var label = self.emailSubmit.querySelector('[data-btn-label]');
          if (label) {
            label.textContent = 'Reveal my scent';
          }
        }
        
        self._goTo(0);
      });
    }

    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var optionBtn = e.target.closest('.scent-quiz-option');
        if (optionBtn && optionBtn.closest('.scent-quiz-options')) {
          e.preventDefault();
          self._selectOption(optionBtn);
        }
      }
    });
  };

  // ==================== CART MONITORING ====================
  
  ScentFinderQuiz.prototype._monitorCart = function () {
    // No need to monitor cart for button state since we're not toggling buttons
    // Keeping this method for future use if needed
  };

  ScentFinderQuiz.prototype._resetButtonsIfNeeded = function () {
    // No longer needed since buttons stay clickable
  };

  ScentFinderQuiz.prototype._deselectAll = function () {
    var opts = this.root.querySelectorAll('.scent-quiz-option.is-selected');
    opts.forEach(function (o) { o.classList.remove('is-selected'); });
  };

  ScentFinderQuiz.prototype._selectOption = function (optionBtn) {
    var questionEl = optionBtn.closest('[data-question]');
    var tag = optionBtn.getAttribute('data-tag');

    var previousSelected = questionEl.querySelector('.scent-quiz-option.is-selected');
    if (previousSelected) {
      var oldTag = previousSelected.getAttribute('data-tag');
      var oldIndex = this.selectedTags.indexOf(oldTag);
      if (oldIndex !== -1) {
        this.selectedTags.splice(oldIndex, 1);
      }
    }

    var siblings = questionEl.querySelectorAll('.scent-quiz-option');
    siblings.forEach(function (s) { s.classList.remove('is-selected'); });
    optionBtn.classList.add('is-selected');

    if (tag) {
      this.selectedTags.push(tag);
    }

    var self = this;
    setTimeout(function () {
      self._goTo(self.currentIndex + 1);
    }, 200);
  };

  ScentFinderQuiz.prototype._goTo = function (index) {
    if (index < 0) index = 0;
    if (index >= ORDER.length) index = ORDER.length - 1;
    this.currentIndex = index;
    this._render();

    if (ORDER[index] === 'result') {
      this._computeResult();
    }

    var card = this.root.querySelector('.scent-quiz-card');
    if (card && window.innerWidth < 740) {
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  ScentFinderQuiz.prototype._render = function () {
    var currentKey = ORDER[this.currentIndex];

    this.questionEls.forEach(function (el) {
      var q = el.getAttribute('data-question');
      el.classList.toggle('is-active', q === currentKey);
    });

    var isQuestionStep = ['1', '2', '3', '4', '5'].indexOf(currentKey) !== -1;
    var trackWrap = this.root.querySelector('[data-progress-track]');

    if (isQuestionStep) {
      if (trackWrap) trackWrap.style.display = '';
      if (this.stepLabel) {
        this.stepLabel.style.display = '';
        this.stepLabel.textContent = 'Question ' + currentKey + ' of 5';
      }
      var pct = (parseInt(currentKey, 10) / 5) * 100;
      if (this.progressFill) this.progressFill.style.width = pct + '%';
    } else {
      if (trackWrap) trackWrap.style.display = 'none';
      if (this.stepLabel) this.stepLabel.style.display = 'none';
      if (this.progressFill) {
        this.progressFill.style.width = (currentKey === 'email' || currentKey === 'result') ? '100%' : '0%';
      }
    }

    if (this.backBtn) {
      this.backBtn.hidden = this.currentIndex === 0 || currentKey === 'result' || currentKey === 'email';
    }

    var activeQuestion = this.root.querySelector('.scent-quiz-question.is-active');
     if (activeQuestion && this._hasInteracted) {   // skip on initial load
    var focusable = activeQuestion.querySelector('button, input, a');
    if (focusable && !focusable.closest('.scent-quiz-result')) {
      setTimeout(function () {
        focusable.focus({ preventScroll: true });  // don't yank the page
      }, 100);
    }
  }
  };

  ScentFinderQuiz.prototype._submitEmail = function () {
    var self = this;
    var email = (this.emailInput.value || '').trim();
    var isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!isValid) {
      this.emailError.hidden = false;
      this.emailInput.focus();
      this.emailInput.classList.add('error');
      return;
    }
    this.emailError.hidden = true;
    this.emailInput.classList.remove('error');

    this.emailSubmit.setAttribute('disabled', 'disabled');
    this.emailSubmit.classList.add('loading');
    var label = this.emailSubmit.querySelector('[data-btn-label]');
    var originalLabel = label ? label.textContent : '';
    if (label) label.textContent = 'Sending…';

    try {
      localStorage.setItem('scent_quiz_email_' + this.sectionId, email);
      localStorage.setItem('scent_quiz_tags_' + this.sectionId, JSON.stringify(this.selectedTags));
    } catch (e) {}

    this._subscribeToNewsletter(email)
      .catch(function (err) {
        console.warn('Scent Finder Quiz: newsletter signup failed', err);
      })
      .finally(function () {
        if (label) label.textContent = originalLabel;
        self.emailSubmit.removeAttribute('disabled');
        self.emailSubmit.classList.remove('loading');
        self._goTo(self.currentIndex + 1);
      });
  };

  ScentFinderQuiz.prototype._subscribeToNewsletter = function (email) {
    var tag = (this.options && this.options.newsletterTag) || 'scent-quiz';
    var formData = new FormData();
    formData.append('form_type', 'customer');
    formData.append('utf8', '✓');
    formData.append('contact[email]', email);
    formData.append('contact[tags]', tag + ', ' + this.selectedTags.join(', '));
    formData.append('contact[accepts_marketing]', 'true');

    return fetch('/contact#newsletter', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Newsletter signup failed');
      }
      return response;
    });
  };

  // ==================== MATCHING LOGIC ====================
  
  ScentFinderQuiz.prototype._computeResult = function () {
    var self = this;
    var selectedTags = this.selectedTags || [];

    if (selectedTags.length === 0) {
      this._renderFallbackResult('No preferences selected. Showing our top picks.');
      return;
    }

    var scored = this.products.map(function (product) {
      var productTags = product.tags || [];
      
      if (typeof productTags === 'string') {
        productTags = productTags.split(',').map(function(t) { return t.trim(); });
      }
      
      var normalizedProductTags = productTags.map(function (t) {
        return t.toLowerCase().trim();
      });

      var normalizedSelectedTags = selectedTags.map(function (t) {
        return t.toLowerCase().trim();
      });

      var matchCount = 0;
      var matchedTags = [];

      normalizedSelectedTags.forEach(function (selectedTag) {
        if (normalizedProductTags.indexOf(selectedTag) !== -1) {
          matchCount++;
          matchedTags.push(selectedTag);
        }
      });

      normalizedSelectedTags.forEach(function (selectedTag) {
        normalizedProductTags.forEach(function (productTag) {
          if (productTag.indexOf(selectedTag) !== -1 && matchedTags.indexOf(selectedTag) === -1) {
            matchCount += 0.5;
            matchedTags.push(selectedTag);
          }
        });
      });

      if (product.available !== false) {
        matchCount += 0.5;
      }

      return {
        product: product,
        matchCount: matchCount,
        matchedTags: matchedTags,
        matchPercentage: (matchCount / selectedTags.length) * 100,
        allTags: productTags
      };
    });

    scored.sort(function (a, b) {
      return b.matchCount - a.matchCount;
    });

    var topMatches = scored.filter(function (s) {
      return s.matchCount > 0 && s.product.available !== false;
    });

    if (topMatches.length >= 2 && topMatches[0].matchCount >= 2) {
      var primary = topMatches[0];
      var secondary = topMatches[1] || topMatches[0];
      this._renderResult(primary, secondary);
      return;
    }

    if (topMatches.length >= 1 && topMatches[0].matchCount >= 2) {
      var primary = topMatches[0];
      var secondary = topMatches[1] || scored.find(function (s) {
        return s.product.id !== primary.product.id && s.product.available !== false;
      }) || primary;
      this._renderResult(primary, secondary);
      return;
    }

    this._renderFallbackResult('We found some great options for you.');
  };

  ScentFinderQuiz.prototype._renderFallbackResult = function (message) {
    var availableProducts = [];
    
    if (this.fallbackProducts && this.fallbackProducts.length > 0) {
      availableProducts = this.fallbackProducts.filter(function (p) {
        return p.available !== false;
      });
    }
    
    if (availableProducts.length === 0) {
      availableProducts = this.products.filter(function (p) {
        return p.available !== false;
      });
    }

    if (availableProducts.length >= 2) {
      var primary = { product: availableProducts[0], matchCount: 0, matchedTags: [] };
      var secondary = { product: availableProducts[1], matchCount: 0, matchedTags: [] };
      this._renderResult(primary, secondary, true);
    } else if (availableProducts.length === 1) {
      var primary = { product: availableProducts[0], matchCount: 0, matchedTags: [] };
      this._renderResult(primary, primary, true);
    } else {
      this.resultTitle.textContent = 'No products found. Please add products to your store.';
      if (this.resultProducts) this.resultProducts.innerHTML = '';
    }
  };

  ScentFinderQuiz.prototype._renderResult = function (primary, secondary, isFallback) {
    if (!primary || !primary.product) {
      this.resultTitle.textContent = 'No products found. Please add products to your store.';
      return;
    }

    var p = primary.product;
    var s = secondary ? secondary.product : null;

    var template = (this.options && this.options.resultHeadingTemplate) || 'Your matched scent: {primary} / {secondary}';
    var title = s && s.id !== p.id
      ? template.replace(/\{primary\}/g, p.title).replace(/\{secondary\}/g, s.title)
      : p.title;

    this.resultTitle.textContent = title;

    if (this.resultNote) {
      if (isFallback) {
        this.resultNote.textContent = 'Based on your preferences, we think you\'ll love these.';
      } else if (s && s.id !== p.id) {
        this.resultNote.textContent = 'Pair ' + p.title + ' with ' + s.title + ' for the perfect combination.';
      } else {
        this.resultNote.textContent = 'A perfect match for your preferences.';
      }
    }

    if (this.resultProducts) {
      this.resultProducts.innerHTML = '';
      var productsToShow = [p, s].filter(function (prod) { return prod && prod.id; });

      var seen = {};
      var uniqueProducts = productsToShow.filter(function (prod) {
        if (seen[prod.id]) return false;
        seen[prod.id] = true;
        return true;
      });

      var self = this;
      uniqueProducts.forEach(function (product, index) {
        var card = document.createElement('div');
        card.className = 'scent-quiz-result-product';

        var imageHtml = product.image
          ? '<img src="' + product.image + '" alt="' + product.title + '" loading="lazy">'
          : '<div class="sq-img-placeholder" aria-hidden="true">🌿</div>';

        var priceHtml = product.price ? '<p class="sq-price">$' + (product.price / 100).toFixed(2) + '</p>' : '';

        var tagText = index === 0 ? '⭐ Perfect Match' : '✨ Also Great';

        var buttonHtml;
        if (!product.variantId) {
          buttonHtml = '<a class="scent-quiz-btn scent-quiz-btn-primary sq-add-btn" href="' + (product.url || '#') + '">View Product</a>';
        } else if (product.available === false) {
          buttonHtml = '<button type="button" class="scent-quiz-btn scent-quiz-btn-ghost sq-add-btn" disabled>Sold Out</button>';
        } else {
          buttonHtml =
            '<button type="button" class="scent-quiz-btn scent-quiz-btn-primary sq-add-btn" data-add-to-cart data-variant-id="' + product.variantId + '" data-product-title="' + product.title + '">' +
              '<span>Add to Cart</span>' +
            '</button>';
        }

        card.innerHTML =
          '<a class="sq-product-link" href="' + (product.url || '#') + '">' +
            imageHtml +
            '<p class="sq-tag">' + tagText + '</p>' +
            '<p class="sq-name">' + product.title + '</p>' +
            priceHtml +
          '</a>' +
          buttonHtml;

        self.resultProducts.appendChild(card);
      }, this);
    }
  };

  ScentFinderQuiz.prototype._addToCart = function (btn) {
    var self = this;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.hasAttribute('disabled')) return;

    // Get product title for toast message
    var productTitle = btn.getAttribute('data-product-title') || 'Product';

    btn.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        // Show toast notification
        self._showToast('✓ ' + productTitle + ' added to cart');
        
        // Trigger cart refresh events
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:update'));
        
        // Re-enable the button
        btn.removeAttribute('disabled');
      })
      .catch(function (err) {
        console.warn('Scent Finder Quiz: add to cart failed', err);
        btn.removeAttribute('disabled');
      });
  };

  window.ScentFinderQuiz = {
    instances: {},
    init: function (sectionId, options) {
      if (this.instances[sectionId]) {
        this.instances[sectionId] = new ScentFinderQuiz(sectionId, options);
      } else {
        this.instances[sectionId] = new ScentFinderQuiz(sectionId, options);
      }
      return this.instances[sectionId];
    },
    restart: function (sectionId) {
      if (this.instances[sectionId]) {
        var instance = this.instances[sectionId];
        instance.selectedTags = [];
        instance._deselectAll();
        
        if (instance.emailInput) {
          instance.emailInput.value = '';
          instance.emailInput.classList.remove('error');
        }
        if (instance.emailError) {
          instance.emailError.hidden = true;
        }
        if (instance.emailSubmit) {
          instance.emailSubmit.removeAttribute('disabled');
          instance.emailSubmit.classList.remove('loading');
          var label = instance.emailSubmit.querySelector('[data-btn-label]');
          if (label) {
            label.textContent = 'Reveal my scent';
          }
        }
        
        instance._goTo(0);
      }
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    var quizSections = document.querySelectorAll('[data-scent-quiz-data]');
    quizSections.forEach(function (script) {
      var sectionId = script.getAttribute('data-scent-quiz-data');
      if (sectionId && !window.ScentFinderQuiz.instances[sectionId]) {
        window.ScentFinderQuiz.init(sectionId);
      }
    });
  });
})();